const restaurant = {
  restaurant: "Restaurante", // translated
  restaurants: "Restaurantes", // translated
  category: "Categoria", // translated
  score: "Pontuação", // translated
  priceQuartile: "Quartil de preço", // translated
  scoreLowestFirst: "Pontuação (menor primeiro)", // translated
  scoreHighestFirst: "Pontuação (mais alta primeiro)", // translated
  priceLowestFirst: "Preço: mais baixos primeiro)", // translated
  priceHighestFirst: "Preço: Mais caro primeiro)", // translated
  allPrices: "Todos os preços", // translated
  reserve: "reserva", // translated
  dining: "Jantar", // translated
};


export default restaurant;
